<template>
  <SideBar title="En Construcción...">
    <div id="blank_parent" v-html="require(`!html-loader!../../assets/illustrations/en_construccion_trabajador.svg`)"></div>
  </SideBar>
</template>

<style module>
#blank_parent svg {
  max-width: 100%;
  max-height: 100vh;
  padding: 4rem;
}
@media (max-width: 500px) {
  #blank_parent svg {
    padding: 0rem;
  }
}
</style>

<script>
import SideBar from "../../components/SideBar";

export default {
  name: "WorkerHome",
  components: {
    SideBar
  }
};
</script>